import styled from "styled-components";

export const DailySettlementSummaryTabWrapper = styled.div<{ left: string }>`
  width: 100%;
  display: flex;
  border-bottom: 2px solid #d9d9d9;
  box-sizing: border-box;
  gap: 20px;
  position: relative;
  padding-bottom: 13px;

  > .border {
    position: absolute;
    border: 2px solid #7f25fb;
    width: 75px;
    height: 0;
    border-radius: 13px;
    bottom: -2px;
    left: ${(p) => p.left};
    transition: all 0.3s;
  }
`;

export const DailySettlementSummaryTabItem = styled.div<{
  isSelected: boolean;
}>`
  box-sizing: border-box;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  color: ${(p) => (p.isSelected ? "#7f25fb" : "#bebebe")};
  width: 75px;
  transition: all 0.3s;
  cursor: pointer;
`;

export const DailySettlementSummaryWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 50px;
`;

export const DailySettlementSummaryRevenueBoxWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const DailySettlementSummaryContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  > .name {
    width: 250px;

    > .info {
      font-weight: 500;
      font-size: 19px;
    }
  }
`;

export const DailySettlementSummaryBalanceBox = styled.div`
  margin-left: 30px;
  display: flex;
  gap: 30px;

  > .button {
    background: #373636;
    width: max-content;
    height: 21px;
    border-radius: 15px;
    padding: 0 20px;
    font-weight: 700;
    font-size: 13px;
    line-height: 21px;
    color: #fff;
    cursor: pointer;
  }
`;

export const DailySettlementSummaryBalanceBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
